/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Listings_To_ShareInputs */

const en_no_listings_to_share = /** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listings found to share.`)
};

const es_no_listings_to_share = /** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron anuncios para compartir.`)
};

const fr_no_listings_to_share = /** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune annonce trouvée à partager.`)
};

const de_no_listings_to_share = /** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Inserate zum Teilen gefunden.`)
};

const id_no_listings_to_share = /** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada listing yang ditemukan untuk dibagikan.`)
};

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const ja_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const zh_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const ar_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const it_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const ru_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const pt_no_listings_to_share = en_no_listings_to_share;

/** @type {(inputs: No_Listings_To_ShareInputs) => LocalizedString} */
const ko_no_listings_to_share = en_no_listings_to_share;

/**
* | output |
* | --- |
* | "No listings found to share." |
*
* @param {No_Listings_To_ShareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_listings_to_share = /** @type {((inputs?: No_Listings_To_ShareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Listings_To_ShareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_listings_to_share(inputs)
	if (locale === "es") return es_no_listings_to_share(inputs)
	if (locale === "fr") return fr_no_listings_to_share(inputs)
	if (locale === "de") return de_no_listings_to_share(inputs)
	if (locale === "ja") return ja_no_listings_to_share(inputs)
	if (locale === "zh") return zh_no_listings_to_share(inputs)
	if (locale === "ar") return ar_no_listings_to_share(inputs)
	if (locale === "id") return id_no_listings_to_share(inputs)
	if (locale === "it") return it_no_listings_to_share(inputs)
	if (locale === "ru") return ru_no_listings_to_share(inputs)
	if (locale === "pt") return pt_no_listings_to_share(inputs)
	return ko_no_listings_to_share(inputs)
});